// extracted by mini-css-extract-plugin
module.exports = {"modal":"JtUI9a9sB72imwIbSRoTy","imageRow":"GIJ8Ldogp18wSvm3H3H82","description":"kVqeFfFHd6aYHNw5p6ijH","footer":"_1jLKjA2DfNoam686DwPAo7"};